<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="isLoaded">
      <div class="btn">
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          color="red"
          :top="y === 'top'"
        >
          {{ errorMsg }}
          <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-toolbar flat color="white">
        <v-toolbar-title></v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- view page start here -->
        <v-dialog v-model="dialog">
          <template>
            <v-layout row>
              <v-flex xs12 sm6 offset-sm3>
                <v-container fluid>
                  <!-- project information details -->
                  <project-details-info :ProjectData="editedItem" />
                  <assigned-agent-group-to-project
                    v-if="editedItem.project_type_id === 3"
                    :project_id="editedItem.id"
                  ></assigned-agent-group-to-project>
                  <assigned-teams-to-project
                    v-if="editedItem.dasher_category_id === 2"
                    :project_id="editedItem.id"
                  ></assigned-teams-to-project>
                  <!-- pre survey question start -->
                  <v-layout row v-if="checkData">
                    <v-flex xs12>
                      <v-card>
                        <v-card-title class="project white--text">
                          <div class="headline">
                            Project Pre Survey Questions
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <div
                            v-for="(pre_ques, index) in editedItem.pre_question"
                            v-bind:key="index"
                          >
                            <!-- question part -->
                            <div>
                              <span>Pre_Q{{ index + 1 }}.</span>
                              <span
                                v-if="
                                  editedItem.project_language == 1 ||
                                  editedItem.project_language == 3
                                "
                              >
                                <span class="font-weight-bold">
                                  Question Title English:
                                </span>
                                &nbsp;&nbsp;&nbsp;{{
                                  pre_ques.question_title_en
                                }}
                              </span>
                              <br />
                              <span
                                v-if="
                                  editedItem.project_language == 2 ||
                                  editedItem.project_language == 3
                                "
                              >
                                &nbsp;&nbsp;&nbsp;
                                <span class="font-weight-bold">
                                  Question Title Bangla:
                                </span>
                                &nbsp;&nbsp;&nbsp;{{
                                  pre_ques.question_title_bn
                                }}
                                <br />
                              </span>
                              <!-- option and multiple image section -->
                              <div
                                v-if="
                                  pre_ques.ui_category_id == 1 ||
                                  pre_ques.ui_category_id == 2 ||
                                  pre_ques.ui_category_id == 4 ||
                                  pre_ques.ui_category_id == 14
                                "
                              >
                                <div v-if="pre_ques.ui_category_id == 14">
                                  <span
                                    v-for="(
                                      option, i
                                    ) in pre_ques.pre_image_options"
                                    :key="i"
                                  >
                                    <v-img
                                      height="150"
                                      width="200"
                                      :src="
                                        indexData.dataStatus2.pre_image_op +
                                        option.url
                                      "
                                    ></v-img>
                                    <a
                                      :href="
                                        indexData.dataStatus2.pre_image_op +
                                        option.url
                                      "
                                      target="_blank"
                                    >
                                      download
                                    </a>
                                    <div class="mt-3"></div>
                                  </span>
                                </div>
                                <div v-else>
                                  <div
                                    v-if="
                                      editedItem.project_language == 1 ||
                                      editedItem.project_language == 3
                                    "
                                  >
                                    <span class="font-weight-bold">
                                      Option English:
                                    </span>
                                    <br />
                                    <span
                                      v-for="(
                                        option, i
                                      ) in pre_ques.pre_options"
                                      :key="i"
                                    >
                                      <v-icon small>
                                        radio_button_unchecked
                                      </v-icon>
                                      {{ option.title }}
                                      <br />
                                    </span>
                                  </div>
                                  <div
                                    v-if="
                                      editedItem.project_language == 2 ||
                                      editedItem.project_language == 3
                                    "
                                  >
                                    <br />
                                    <span class="font-weight-bold">
                                      Option Bangla:
                                    </span>
                                    <br />
                                    <span
                                      v-for="(
                                        option, i
                                      ) in pre_ques.pre_bangla_options"
                                      :key="i"
                                    >
                                      <v-icon small>
                                        radio_button_unchecked
                                      </v-icon>
                                      {{ option.title }}
                                      <br />
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <!-- instruction and description -->
                              <div>
                                <span
                                  v-if="
                                    pre_ques.pre_instruction != null &&
                                    (editedItem.project_language == 1 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Instruction:
                                  </span>
                                  <br />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="pre_ques.instruction.instruction"
                                  ></div>
                                </span>
                                <span
                                  v-if="
                                    pre_ques.pre_instruction_bangla != null &&
                                    (editedItem.project_language == 2 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Instruction Bangla:
                                  </span>
                                  <br />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      pre_ques.pre_instruction_bangla
                                        .instruction_bangla
                                    "
                                  ></div>
                                </span>

                                <span
                                  v-if="
                                    pre_ques.pre_description != null &&
                                    (editedItem.project_language == 1 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Description:
                                  </span>
                                  <br />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      pre_ques.pre_description.description
                                    "
                                  ></div>
                                </span>
                                <span
                                  v-if="
                                    pre_ques.pre_description_bangla != null &&
                                    (editedItem.project_language == 2 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Description Bangla:
                                  </span>
                                  <br />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      pre_ques.pre_description_bangla
                                        .description_bangla
                                    "
                                  ></div>
                                </span>
                              </div>
                            </div>
                            <div>
                              <pre-survey-question-logic
                                :pre_question_logic="
                                  pre_ques.pre_question_logic
                                "
                                :operators="indexData.operators"
                              />
                            </div>
                            <!-- comment section -->
                            <div>
                              <v-expansion-panel>
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div class="green--text">
                                      If any comments
                                    </div>
                                  </template>
                                  <v-card>
                                    <v-card-text>
                                      <v-textarea
                                        v-model.lazy="
                                          comments.add_pre_comments[index]
                                            .pre_comment
                                        "
                                        label="Write your comments here"
                                        box
                                      ></v-textarea>
                                    </v-card-text>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </div>
                          </div>
                          <!-- end question section -->
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <!-- pre survey question end -->

                  <!-- question start  -->
                  <v-layout row>
                    <v-flex xs12>
                      <v-card>
                        <v-card-title class="project white--text">
                          <div class="headline">Project Questions</div>
                        </v-card-title>
                        <v-card-text>
                          <!-- start question section -->
                          <span class="font-weight-bold">
                            Note:Here star mark (
                            <span class="red--text">*</span>
                            ) is required.
                          </span>
                          <br />
                          <div
                            v-for="(ques, index) in editedItem.question"
                            v-bind:key="index"
                          >
                            <!-- question part -->
                            <div>
                              <span>{{ index + 1 }}.</span>
                              <span
                                v-if="
                                  editedItem.project_language == 1 ||
                                  editedItem.project_language == 3
                                "
                              >
                                <span class="font-weight-bold">
                                  Question Title English:
                                </span>
                                &nbsp;&nbsp;&nbsp;{{ ques.question }}
                                <span
                                  class="red--text headline"
                                  v-if="ques.required_optional == 1"
                                >
                                  *
                                </span>
                              </span>
                              <br />
                              <span
                                v-if="
                                  editedItem.project_language == 2 ||
                                  editedItem.project_language == 3
                                "
                              >
                                &nbsp;&nbsp;&nbsp;
                                <span class="font-weight-bold">
                                  Question Title Bangla:
                                </span>
                                &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }}
                                <br />
                                <span
                                  class="red--text headline"
                                  v-if="ques.required_optional == 1"
                                >
                                  *
                                </span>
                              </span>
                              <div v-if="ques.ui_category_id == 15">
                                <span
                                  v-if="ques.contact_info.first_name == '1'"
                                >
                                  First Name: _________
                                </span>
                                <span
                                  v-if="ques.contact_info.middle_name == '1'"
                                >
                                  <br />
                                  Middle Name: _________
                                </span>
                                <span v-if="ques.contact_info.last_name == '1'">
                                  <br />
                                  Last Name: _________
                                </span>
                                <span v-if="ques.contact_info.phone == '1'">
                                  <br />
                                  <v-icon small>call</v-icon>
                                  Phone: _________
                                </span>
                                <span v-if="ques.contact_info.email == '1'">
                                  <br />
                                  email: _________
                                </span>
                                <span v-if="ques.contact_info.address == '1'">
                                  <br />
                                  <v-icon small>home</v-icon>
                                  <span class="font-weight-bold">Address:</span>
                                  <br />
                                  Country: _________
                                  <br />
                                  Division: _________
                                  <br />
                                  District : _________
                                  <br />
                                  Area: _________
                                  <br />
                                  Road No: _________
                                  <br />
                                  House No: _________
                                </span>
                              </div>
                              <!-- option and multiple image section -->

                              <div
                                v-if="
                                  ques.ui_category_id == 1 ||
                                  ques.ui_category_id == 2 ||
                                  ques.ui_category_id == 4 ||
                                  ques.ui_category_id == 14
                                "
                              >
                                <div v-if="ques.image_options">
                                  <div v-if="ques.ui_category_id == 14">
                                    <span
                                      v-for="(option, i) in ques.image_options"
                                      :key="i"
                                    >
                                      <v-img
                                        height="150"
                                        width="200"
                                        :src="
                                          indexData.dataStatus2.image_op +
                                          option.url
                                        "
                                      ></v-img>
                                      <a
                                        :href="
                                          indexData.dataStatus2.image_op +
                                          option.url
                                        "
                                        target="_blank"
                                      >
                                        download
                                      </a>
                                      <div class="mt-3"></div>
                                    </span>
                                  </div>
                                  <div v-else>
                                    <div
                                      v-if="
                                        editedItem.project_language == 1 ||
                                        editedItem.project_language == 3
                                      "
                                    >
                                      <span class="font-weight-bold">
                                        Option English:
                                      </span>
                                      <br />
                                      <span
                                        v-for="(option, i) in ques.options"
                                        :key="i"
                                      >
                                        <v-icon small>
                                          radio_button_unchecked
                                        </v-icon>
                                        {{ option.title }}
                                        <br />
                                      </span>
                                    </div>
                                    <div
                                      v-if="
                                        editedItem.project_language == 2 ||
                                        editedItem.project_language == 3
                                      "
                                    >
                                      <br />
                                      <span class="font-weight-bold">
                                        Option Bangla:
                                      </span>
                                      <br />
                                      <span
                                        v-for="(
                                          option, i
                                        ) in ques.bangla_options"
                                        :key="i"
                                      >
                                        <v-icon small>
                                          radio_button_unchecked
                                        </v-icon>
                                        {{ option.title }}
                                        <br />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- instruction and description -->
                              <div>
                                <span
                                  v-if="
                                    ques.instruction != null &&
                                    (editedItem.project_language == 1 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Instruction:
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      parseDataToJson(
                                        ques.instruction.instruction
                                      )
                                    "
                                  ></div>
                                </span>
                                <span
                                  v-if="
                                    ques.instruction_bangla != null &&
                                    (editedItem.project_language == 2 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Instruction Bangla:
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      parseDataToJson(
                                        ques.instruction_bangla
                                          .instruction_bangla
                                      )
                                    "
                                  ></div>
                                </span>

                                <span
                                  v-if="
                                    ques.description != null &&
                                    (editedItem.project_language == 1 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Description:
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      parseDataToJson(
                                        ques.description.description
                                      )
                                    "
                                  ></div>
                                </span>
                                <span
                                  v-if="
                                    ques.description_bangla != null &&
                                    (editedItem.project_language == 2 ||
                                      editedItem.project_language == 3)
                                  "
                                >
                                  <span class="font-weight-bold">
                                    Description Bangla:
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    v-html="
                                      parseDataToJson(
                                        ques.description_bangla
                                          .description_bangla
                                      )
                                    "
                                  ></div>
                                </span>
                              </div>
                              <!-- multiple answer -->
                              <div v-if="ques.ui_category_id == 2">
                                <span class="font-weight-bold">
                                  Multiple ans:
                                </span>
                                <v-icon small class="mr-1">
                                  check_box_outline_blank
                                </v-icon>
                                <span v-if="ques.multiple_answer == 1">
                                  yes
                                </span>
                                <span v-else>no</span>
                              </div>
                              <!-- range slider star rating -->
                              <div
                                v-if="
                                  ques.ui_category_id == 6 ||
                                  ques.ui_category_id == 7 ||
                                  ques.ui_category_id == 8
                                "
                              >
                                <span
                                  class="font-weight-bold"
                                  v-if="
                                    ques.option_val != null &&
                                    ques.option_val != null
                                  "
                                >
                                  Min value:{{ ques.option_val.min_value }}
                                  <br />
                                  Max value:{{ ques.option_val.max_value }}
                                </span>
                                <span
                                  class="font-weight-bold"
                                  v-if="ques.option_val != null"
                                >
                                  <br />
                                  interval:{{ ques.option_val.interval }}
                                </span>
                              </div>
                            </div>
                            <!-- question logic block -->
                            <div v-if="ques.has_logic">
                              <question-logic
                                :question_logic="
                                  parseDataToJson(
                                    ques.question_logic.question_logic
                                  )
                                "
                                :questions="editedItem.question"
                                :counter_index="index"
                              />
                            </div>
                            <!-- comment section -->
                            <br />
                            <div>
                              <v-expansion-panel>
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div class="green--text">
                                      If any comments
                                    </div>
                                  </template>
                                  <v-card>
                                    <v-card-text>
                                      <v-textarea
                                        @keypress="keyPress(index)"
                                        @keyup="removeEvent(index)"
                                        v-model.lazy="
                                          comments.add_comments[index].comment
                                        "
                                        label="Write your comments here"
                                        box
                                      ></v-textarea>
                                    </v-card-text>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </div>
                            <br />
                          </div>
                          <!-- end question section -->
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <!-- question end  -->
                </v-container>
                <v-divider inset></v-divider>
                <v-container fluid>
                  <v-list-tile-title class="font-weight-bold text-sm-center">
                    Comments
                  </v-list-tile-title>
                  <v-layout row justify-space-around>
                    <v-flex xs12>
                      <v-card>
                        <v-card-text class="px-1">
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-textarea
                              v-model="comments.final_comment"
                              :rules="commentRules"
                              label="Overall Comments"
                              box
                              required
                            ></v-textarea>
                          </v-form>
                          <!-- <v-text-field v-model="comments.description" box label="Comment should be separated by (,) comma"></v-text-field> -->
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-divider inset></v-divider>
                <!-- <v-container fluid>
                  <v-list-tile-title class="font-weight-bold text-sm-center">
                    Set Payment Value
                  </v-list-tile-title>
                  <v-layout row justify-space-around>
                    <v-flex xs12>
                      <v-card>
                        <v-card-text class="px-1">
                          <v-form>
                            <v-layout align="center" justify="space-around">
                              <v-btn color="primary" @click="percentValue">
                                Percentage
                              </v-btn>
                              <v-btn color="success" @click="amountValue">
                                Amount
                              </v-btn>
                            </v-layout>
                            <v-layout>
                              <v-flex xs12 md8 class="mt-2">
                                <v-subheader class="black--text">
                                  Total amount:
                                  {{ editedItem.total_budget_amount }} Tk
                                </v-subheader>
                              </v-flex>
                            </v-layout>
                            <v-layout row v-if="percentage">
                              <v-flex sx12 md2 shrink style="width: 60px">
                                <v-text-field
                                  v-model="slider"
                                  class="ma-2"
                                  hide-details
                                  single-line
                                  prefix="%"
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 md8 class="ml-2 mt-3">
                                <v-slider
                                  @change="changePercentage"
                                  v-model="slider"
                                  :max="max"
                                  :min="min"
                                ></v-slider>
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-text-field
                                  class="ml-2"
                                  readonly
                                  v-model="paymentData.payableAmount"
                                  :value="minPayment"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row v-if="amount">
                              <v-flex>
                                <v-text-field
                                  v-model="paymentData.payableAmount"
                                  class="ma-2"
                                  type="number"
                                  label="Amount"
                                  prefix="Tk:"
                                  :rules="[
                                    (v) => !!v || 'This field is required!',
                                    (v) => (v && v >= 0) || 'Minimum input 0',
                                    (v) =>
                                      (v &&
                                        v <= editedItem.total_budget_amount) ||
                                      'Exceeded maximum amount',
                                  ]"
                                  outline
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-flex class="ml-2">
                                <v-switch
                                  v-model="paymentData.resDownloadStatus"
                                  :label="`Allow response download before full payment`"
                                ></v-switch>
                              </v-flex>
                            </v-layout>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container> -->
                <v-divider inset></v-divider>
                <v-container fluid v-if="editedItem.project_type_id == 2">
                  <v-list-tile-title class="font-weight-bold text-sm-center">
                    Project distance verification status
                  </v-list-tile-title>
                  <v-layout row justify-space-around>
                    <v-flex xs12>
                      <v-card>
                        <v-card-text class="px-1">
                          <v-layout row>
                            <v-flex xs6>
                              <v-subheader
                                class="black--text font-weight-regular"
                              >
                                Visual distance
                              </v-subheader>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader>
                                {{ editedItem.visual_radius_km }} Km
                              </v-subheader>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <v-subheader
                                class="black--text font-weight-regular"
                              >
                                Acceptable distance
                              </v-subheader>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader>
                                {{ editedItem.acceptance_radius_m }} Meter
                              </v-subheader>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <v-subheader
                                class="black--text font-weight-regular"
                              >
                                Verification status
                              </v-subheader>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader>
                                {{
                                  editedItem.project_radius_status_id == 1
                                    ? "Pending"
                                    : "System default"
                                }}
                              </v-subheader>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            v-if="editedItem.project_radius_status_id == 1"
                          >
                            <v-flex class="ml-2">
                              <v-switch
                                v-model="paymentData.project_radius_status"
                                :label="`Allow for approved`"
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>

            <!-- <v-divider inset></v-divider> -->
            <v-container fluid>
              <v-layout row>
                <div>
                  <v-btn color="success" @click="verifyItem()">Verify</v-btn>
                  <v-btn color="red" @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="editItem(editedItem)">
                    Modify
                  </v-btn>
                  <v-btn color="warning" @click="rejectItem(editedItem)">
                    Reject
                  </v-btn>
                </div>
              </v-layout>
            </v-container>
          </template>
        </v-dialog>
        <!-- view page end here -->
      </v-toolbar>
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataStatus2.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataStatus2.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.dataStatus2.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.project_type_name }}</td>
          <td>{{ props.item.begin_date }}</td>
          <td>{{ props.item.end_date }}</td>
          <td>{{ props.item.total_budget_amount }}</td>
          <td>{{ props.item.per_survey_cost }}</td>
          <td>{{ props.item.number_of_response }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataStatus2.from }} -
          {{ indexData.dataStatus2.to }} of {{ indexData.dataStatus2.total }}
        </template>
      </v-data-table>
      <template v-if="indexData.dataStatus2.total > 0">
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataStatus2.current_page"
            :length="indexData.dataStatus2.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {
    ProjectDetailsInfo,
    QuestionLogic,
    PreSurveyQuestionLogic,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  } from "@/components/index";
  export default {
    components: {
      ProjectDetailsInfo,
      QuestionLogic,
      PreSurveyQuestionLogic,
      AssignedAgentGroupToProject,
      AssignedTeamsToProject,
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      // apiUrl: 'change-status',
      routePath: "/pending",
      switch1: true,
      min: 0,
      max: 100,
      slider: 50,
      percentage: false,
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      amount: false,
      setPayValue: 0,
      sl: 1,
      headers: [
        { text: "Project Id", align: "left", value: "id" },
        { text: "Project Title", align: "left", value: "name" },
        { text: "Project Type", value: "project_type_id" },
        { text: "Project Starting Time", value: "begin_date" },
        { text: "Project Ending Time", value: "end_date" },
        { text: "Total Budget", value: "total_budget_amount" },
        { text: "Per Survey Cost", value: "per_survey_cost" },
        { text: "Total Response", value: "number_of_response" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      commentVal: 0,
      comment_array: [],
      comments: {
        add_comments: [],
        add_pre_comments: [],
        project_id: null,
        final_comment: null,
      },
      paymentData: {
        project_id: null,
        // payableAmount: 0,
        // resDownloadStatus: false,
        project_radius_status: false,
      },
      valid: true,
      commentRules: [(v) => !!v || "This field is required"],
      editedItem: {},
      defaultItem: {},
      project_types: {
        project_type_name: "",
        min_price: "",
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataStatus2) {
          return true;
        } else {
          return false;
        }
      },
      checkData() {
        if (this.editedItem) {
          if (this.editedItem.has_pre_survey) {
            return 1;
          } else {
            return 0;
          }
        }
        return 0;
      },
      minPayment: function () {
        return this.changePercentage();
      },
    },

    watch: {
      pagination() {
        this.paginationMethod();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.reloading();
    },

    methods: {
      reloading() {
        this.$store.dispatch("changeProjectStatus", [
          "status-list",
          2,
          "",
          1,
          5,
        ]);
      },

      initialize() {
        this.paginationMethod();
      },
      parseDataToJson(value) {
        if (value != undefined) {
          return JSON.parse(value);
        }
        return "";
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
        this.close();
      },
      getProjectLanguage(project_language) {
        if (project_language == 1) {
          return "English";
        } else if (project_language == 2) {
          return "Bangla";
        } else {
          return "English & Bangla both";
        }
      },
      percentValue() {
        this.percentage = true;
        this.amount = false;
        this.setPayValue = 1;
      },
      amountValue() {
        this.amount = true;
        this.percentage = false;
        this.setPayValue = 1;
      },
      changePercentage() {
        let percentage =
          (this.editedItem.total_budget_amount * this.slider) / 100;
        this.paymentData.payableAmount = percentage;
        return percentage;
      },
      keyPress(index) {
        if (!this.comment_array.includes(index)) {
          this.comment_array.push(index);
        }
        // console.log(this.comment_array);
      },
      removeEvent(index) {
        if (this.comments.add_comments[index].comment.length === 0) {
          if (this.comment_array.includes(index)) {
            var current_data_index = this.comment_array.indexOf(index);
            this.comment_array.splice(current_data_index, 1);
          }
          // console.log(this.comment_array);
        }
      },
      checkItem(item) {
        // console.log(item)
        //create empty array to contain comment
        if (this.indexData.dataStatus2.data) {
          // this.paymentData.payableAmount = 0;
          this.paymentData.project_id = null;
          // this.paymentData.resDownloadStatus = false;
          this.editedIndex = this.indexData.dataStatus2.data.indexOf(item);
          while (this.comments.add_comments.length > 0) {
            this.comments.add_comments.length = 0;
          }
          if (this.comments.add_pre_comments.length > 0) {
            this.comments.add_pre_comments.length = 0;
          }
          this.comments.final_comment = null;

          for (
            let index = 0;
            index <
            this.indexData.dataStatus2.data[this.editedIndex].totalQuestion;
            index++
          ) {
            this.comments.add_comments.push({
              project_id: item.id,
              question_id:
                this.indexData.dataStatus2.data[this.editedIndex].question[
                  index
                ].id,
              comment: null,
            });
          }
          if (this.indexData.dataStatus2.data[this.editedIndex].pre_question) {
            this.indexData.dataStatus2.data[
              this.editedIndex
            ].pre_question.forEach((element) => {
              this.comments.add_pre_comments.push({
                project_id: item.id,
                pre_question_id: element.id,
                pre_comment: null,
              });
            });
          }

          this.editedItem = Object.assign({}, item);
          this.project_types.project_type_name = item.project_type_name;
          this.project_types.min_price = item.min_price;
          // this.paymentData.payableAmount =
          // (this.editedItem.total_budget_amount * this.slider) / 100;
          this.paymentData.project_id = item.id;
          this.dialog = true;
        }
      },

      verifyItem() {
        let popUpMsg='';
        // console.log(this.paymentData);
        if (
          this.paymentData.project_radius_status == false &&
          this.editedItem.project_radius_status_id == 1
        ) {
           popUpMsg = confirm(
            "Are you sure you don't want to verify project distance radius?"
          );
          if (popUpMsg) {
            if (this.indexData.dataStatus2.data) {
               popUpMsg = confirm(
                "Are you sure you want to verify this application?"
              );
              if (popUpMsg) {
                this.paymentData.per_page = this.pagination.rowsPerPage;
                this.paymentData.current_page =
                  this.indexData.dataStatus2.current_page;
                this.$store.dispatch("storeOrUpdate", [
                  "verify",
                  this.paymentData,
                ]);
              }
              this.close();
            }
          }
        } else {
          if (this.indexData.dataStatus2.data) {
            this.paymentData.project_radius_status = 2;
             popUpMsg = confirm(
              "Are you sure you want to verify this application?"
            );
            if (popUpMsg) {
              this.paymentData.per_page = this.pagination.rowsPerPage;
              this.paymentData.current_page =
                this.indexData.dataStatus2.current_page;
              this.$store.dispatch("storeOrUpdate", [
                "verify",
                this.paymentData,
              ]);
            }

            this.close();
          }
        }
      },

      editItem(item) {
        // console.log(this.comments)
        if (this.$refs.form.validate()) {
          this.comments.project_id = item.id;
          if (this.comment_array.length > 0) {
            let popUpMsg = confirm(
              "Are you sure you want to permit for modification?"
            );
            if (popUpMsg) {
              this.$store.dispatch("modifyProject", [
                "modify-project",
                this.comments,
              ]);
              item.project_status_id = 4;
              this.snackbar = true;
              this.close();
            }
          } else {
            alert("You have to comment at least one question!");
          }
        }
      },

      rejectItem(item) {
        // console.log(item.id)
        // const index = this.indexData.dataStatus2.indexOf(item)
        var popUpMsg = confirm(
          "Are you sure you want to reject this application?"
        );
        if (popUpMsg) {
          this.$store.dispatch("changeProjectStatus", [
            "reject",
            2,
            "",
            this.indexData.dataStatus2.current_page,
            this.pagination.rowsPerPage,
            item.id,
          ]);
          // this.$store.dispatch('changeStatus',[ item.id, 'reject'])
          item.project_status_id = 3;
        }
        this.close();
      },

      close() {
        this.dialog = false;
        this.percentage = false;
        this.amount = false;
        this.slider = 50;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        this.loading = true;
        if (this.indexData.dataStatus2.data) {
          if (this.search) {
            this.$store.dispatch("changeProjectStatus", [
              "status-list",
              2,
              this.search,
              this.indexData.dataStatus2.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = this.indexData.dataStatus2.data ? false : true;
          } else {
            this.$store.dispatch("changeProjectStatus", [
              "status-list",
              2,
              this.search,
              this.indexData.dataStatus2.current_page,
              this.pagination.rowsPerPage,
            ]);
            this.loading = !this.indexData.dataStatus2.error ? false : true;
          }
          this.dialog = false;
        }
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto;
  .project {
    background: #ff2e2e;
  }
</style>
